import React, { createContext, useContext, useState } from 'react';
import Alert, { StatusCode } from '../components/Alert.tsx';

type AlertContextType = {
  showAlert: (statusCode: StatusCode, message: string, duration?: number) => void;
};

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [alerts, setAlerts] = useState<{ id: number; statusCode: StatusCode; message: string }[]>([]);

  const showAlert = (statusCode: StatusCode, message: string, duration: number = 10000) => {
    const id = Date.now();
    setAlerts((prev) => [...prev, { id, statusCode, message }]);

    setTimeout(() => {
      setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    }, duration);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <div className="alert-container position-fixed bottom-0 start-50 translate-middle-x mb-3" style={{ width: '80%', zIndex: 999999999 }}>
        {alerts.map((alert) => (
          <Alert key={alert.id} statusCode={alert.statusCode} message={alert.message} />
        ))}
      </div>
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};
